import { RunSession as View } from "@/components.run/run-session"
export const RunSession = {
	name: "Run.Session",
	path: "/run/sessions/:sessionId",
	component: View,
	meta: {
		title: "Running Session",
		public: true,
		navHidden:true
	}
};